import React from 'react';
import { MessageCircleIcon, BookOpenIcon, UsersIcon, CalendarIcon, FileTextIcon, TrendingUpIcon } from 'lucide-react';
const useCases = [{
  icon: <BookOpenIcon size={24} className="text-[#00A862]" data-id="element-546" />,
  title: 'Lesson Plan Collaboration',
  description: 'Teachers share innovative lesson ideas and teaching strategies. Vote on the best approaches and build a library of proven methods.'
}, {
  icon: <FileTextIcon size={24} className="text-[#00A862]" data-id="element-547" />,
  title: 'Study Resource Library',
  description: 'Create a centralized hub for worksheets, reading materials, and study guides. Students and teachers contribute and access quality resources.'
}, {
  icon: <MessageCircleIcon size={24} className="text-[#00A862]" data-id="element-548" />,
  title: 'Peer Review System',
  description: 'Enable constructive feedback on assignments, projects, and teaching methods. Foster a culture of continuous improvement and learning.'
}, {
  icon: <CalendarIcon size={24} className="text-[#00A862]" data-id="element-549" />,
  title: 'Curriculum Development',
  description: 'Gather input from educators to design and refine curriculum. Collaborate on course structure, learning objectives, and assessment methods.'
}, {
  icon: <UsersIcon size={24} className="text-[#00A862]" data-id="element-550" />,
  title: 'Student Study Groups',
  description: 'Students organize study sessions, share notes, and ask questions. Create collaborative learning spaces that extend beyond the classroom.'
}, {
  icon: <TrendingUpIcon size={24} className="text-[#00A862]" data-id="element-551" />,
  title: 'Professional Development',
  description: 'Collect feedback on teaching workshops and training sessions. Share best practices and resources to support educator growth.'
}];
export function UseCases() {
  return <section id="use-cases" className="py-20 bg-[#F0F9F4]" data-id="element-552">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-553">
        <div className="border-2 border-[#00A862] rounded-xl p-8 bg-white/80 backdrop-blur-sm shadow-md" data-id="element-554">
          <div className="text-center mb-16 border-b border-gray-200 pb-8" data-id="element-555">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-556">
              Built for every aspect of education
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-557">
              From classroom teaching to curriculum planning, Nexio App supports
              educators and students at every step.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-558">
            {useCases.map((useCase, index) => <div key={index} className="p-6 rounded-lg shadow-md hover:shadow-lg transition-all border-2 border-[#00A862] hover:border-[#00A862] hover:bg-[#F0F9F4]" data-id="element-559">
                <div className="mb-4 p-2 inline-block bg-white rounded-lg border border-[#00A862] shadow-sm" data-id="element-560">
                  {useCase.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-561">
                  {useCase.title}
                </h3>
                <div className="bg-gray-50 p-3 rounded-lg shadow-inner" data-id="element-562">
                  <p className="text-gray-600" data-id="element-563">{useCase.description}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}